// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"867":"apply-layout-worker","954":"elk-worker"}[chunkId] + ".js";
};